import { render } from "./BlockHeading.vue?vue&type=template&id=5cf107fa"
import script from "./BlockHeading.vue?vue&type=script&lang=js"
export * from "./BlockHeading.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/BlockEditors/BlockHeading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cf107fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cf107fa', __exports__)) {
    console.log('reload')
    api.reload('5cf107fa', __exports__)
  }
  
  module.hot.accept("./BlockHeading.vue?vue&type=template&id=5cf107fa", () => {
    console.log('re-render')
    api.rerender('5cf107fa', render)
  })

}


export default __exports__